import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const VID_KEY = "korban_vid";

export default function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    let vid = localStorage.getItem(VID_KEY);
    if (!vid) {
      vid = `v-${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;
      localStorage.setItem(VID_KEY, vid);
    }
    api.post("/track", { visitor_id: vid, path: location.pathname }).catch(() => {});
  }, [location.pathname]);

  return null;
}
